// About.js
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./App.css";

function About() {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Felix Ingla</title>
        <meta
          name="description"
          content="Felix Ingla — artist and founder of Pedra, an AI platform for real estate visuals."
        />
      </Helmet>
      <article>
        <p>I'm Felix.</p>

        <p>
          I make art and I build{" "}
          <a
            href="https://pedra.ai"
            rel="noopener"
            alt="Felix Ingla, founder of Pedra"
          >
            Pedra
          </a>
          .
        </p>

        <p>
          Pedra is an AI platform for real estate visuals: staging, photos,
          videos, and 360° tours.
        </p>

        <p>
          You can see my art{" "}
          <Link to="/art" rel="noopener" title="Felix Ingla's Art Portfolio">
            here
          </Link>
          .
        </p>

        <p>
          Contact: <a href="mailto:felix@pedra.ai">felix@pedra.ai</a>
        </p>
      </article>
    </>
  );
}

export default About;
